import { render, staticRenderFns } from "./PopupConfirmationDetail.vue?vue&type=template&id=06adf7ef&"
import script from "./PopupConfirmationDetail.vue?vue&type=script&lang=js&"
export * from "./PopupConfirmationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports